<ng-template [ngIf]="asset.plannedDeletion">
  <mat-icon
    class="mat-error material-icons-outlined pr-6 text-[#1212128F] text-[1.4rem]"
    [matTooltip]="textDeletionOn + ' ' + (asset.plannedDeletion | spDateFormat: { plainDate: true, isSafe: true }) + '.'"
  >
    auto_delete
  </mat-icon>
</ng-template>
